import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Admin } from './admin/Admin';
import { AdminRoute } from './components/AdminRoute';
import { PopUp } from './components/PopUp';
import { ScrollToTop } from './components/ScrollToTop';
import { Router } from './pages/Router';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <BrowserRouter>
      <PopUp />
      <ScrollToTop />
      <Switch>
        <AdminRoute path="/admin" component={Admin} />
        <Route path="/" component={Router} />
      </Switch>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
